import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from "dayjs";
import { Button } from 'antd';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import HasPermissions from "../../../../../containers/HasPermissions";
import VehicleRouteMap from "./VehicleRouteMap";
import { selectedTenantSelector } from "../../../../../store/slice/auth";
import { toInt } from "../../../../../swzutils/TypeUtils";
import { useAppSelector } from "../../../../../store";
const VehicleRouteMapPage = () => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const [stateWorkDate, setStateWorkDate] = useState(searchParams.has('workDate') ? dayjs(searchParams.get('workDate')) : dayjs());
    const [stateVehicleRoute, setStateVehicleRoute] = useState(null);
    useEffect(() => {
        let paramWorkDate = searchParams.get('workDate');
        if (paramWorkDate) {
            const workDate = dayjs(paramWorkDate);
            if (workDate && workDate.isValid() && !workDate.isSame(stateWorkDate, 'day')) {
                setStateWorkDate(workDate);
            }
        }
    }, [searchParams.get('workDate')]);
    const getBackURL = () => {
        return searchParams.get('backUrl');
    };
    const backToCallingView = () => {
        let toUrl = getBackURL() ?? 'app/map/driver';
        navigate(toUrl);
    };
    const onVehicleRouteLoaded = (vehicleRoute) => {
        setStateVehicleRoute(vehicleRoute);
    };
    const goToDriverMap = () => {
        navigate("/app/map/driver");
    };
    const backUrl = getBackURL();
    const vehicleId = toInt(params.vehicleId, 0);
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article fixed-article", children: [_jsxs("h2", { className: "article-title", children: ["Vehicle Route - ", stateVehicleRoute?.vehicle?.registration, _jsx(HasPermissions, { permissions: ['admin:driver:location:list'], children: _jsx(Button, { className: "pull-right hmargin-sm", onClick: goToDriverMap, children: "Driver Map" }) }), backUrl && _jsx(Button, { className: "pull-right hmargin-sm", onClick: backToCallingView, children: "Back" })] }), _jsx("div", { className: "fixed-content-full-height", children: vehicleId &&
                        _jsx(VehicleRouteMap, { settingsTenantId: toInt(searchParams.get("settingsTenantId"), selectedTenant?.id ?? 0), vehicleId: vehicleId, vehicleHireId: toInt(searchParams.get("vehicleHireId"), null), workDate: stateWorkDate, onVehicleRouteLoaded: onVehicleRouteLoaded }) })] }) }));
};
export default VehicleRouteMapPage;
